import Box from "@mui/material/Box";

import LoginHeader from "./components/LoginHeader";
import LoginCard from "./components/LoginCard";
import LoginForm from "./components/LoginForm";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import SideCard from "./components/SideCard";
import useIsMobile from "utils/helpers/mediaQueryHelper";

const styles = {
    root: {
        margin: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        flexDirection: "column",
        background: "#fff"
    }
};

const useStyles = makeStyles(styles);

export default function Login() {
    const classes = useStyles();
    const isMobile = useIsMobile();
    return (
        <Box px={2} className={classes.root}>
            <LoginCard>
                <GridContainer spacing={1} style={{ flexWrap: "nowrap" }}>
                    {!isMobile && (
                        <GridItem>
                            <SideCard />
                        </GridItem>
                    )}
                    <GridItem sx={{ flex: 1 }}>
                        <LoginHeader />
                        <LoginForm />
                    </GridItem>
                </GridContainer>
            </LoginCard>
        </Box>
    );
}
